





























































import {
    Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { TotalActivity } from '@luxtag/papybase';
import TotalActivityChart from '@/components/dashboard/analytics/TotalActivityChart.vue';
import TotalActivityLineChart from '@/components/dashboard/analytics/TotalActivityLineChart';
import { map } from 'lodash';

@Component({
    components: {
        TotalActivityChart,
        TotalActivityLineChart,
    },
})
export default class AnalyticChart extends Vue {
    @Prop() public data!: TotalActivity[];

    public choosenType: number = 1;

    public totalActivityType = [
        {
            index: 0,
            label: 'Hourly',
        },
        {
            index: 1,
            label: 'Daily',
        },
        {
            index: 2,
            label: 'Monthly',
        },
    ];

    public analyticChartEvent(action: string, label: any) {
        this.$ga.event('Analyctic chart', 'click', action, label);
    }

    get totalActivity() {
        if (this.choosenType === 0) {
            return this.$store.getters.getTotalActivitiesDaily;
        } if (this.choosenType === 1) {
            return this.$store.getters.getTotalActivitiesMonthly;
        } return this.$store.getters.getTotalActivitiesYearly;
    }

    get titles() {
        return map(this.totalActivity, a => a.title);
    }

    get counts() {
        // @ts-ignore
        return map(this.totalActivity, a => a.count);
    }

    get chartData() {
        return {
            labels: this.titles,
            datasets: [
                {
                    backgroundColor: 'white',
                    borderColor: this.$vuetify.theme.primary,
                    data: this.counts,
                },
            ],
        };
    }
}
